import React from 'react';
import { CnMessage } from '@alife/cn-ui';
import { componentNameForUrlPage } from "../../const";
import { Placeholder } from "../placeholder";
export default function PrototypeView(props) {
  var url = props.url;
  if (!url) {
    return /*#__PURE__*/React.createElement(Placeholder, null, /*#__PURE__*/React.createElement(CnMessage, {
      type: "notice"
    }, "\u8BF7\u5148\u8F93\u5165\u9875\u9762 url"));
  }
  return /*#__PURE__*/React.createElement(Placeholder, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexFlow: 'column',
      // alignItems: 'center',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", null, "\u5D4C\u5165\u7684\u9875\u9762:", ' ', /*#__PURE__*/React.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noreferrer"
  }, url)), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12,
      color: 'rgba(0,0,0,.6)',
      marginTop: 4
    }
  }, "\u8BF7\u4F7F\u7528\u9884\u89C8\u67E5\u770B\u6548\u679C")));
}
PrototypeView.displayName = componentNameForUrlPage;